/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Settings_Could_Not_Prepare_App_LogsInputs */

const en_settings_could_not_prepare_app_logs = /** @type {(inputs: Settings_Could_Not_Prepare_App_LogsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Could not prepare app logs`)
};

const es_settings_could_not_prepare_app_logs = /** @type {(inputs: Settings_Could_Not_Prepare_App_LogsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No se pudieron preparar los registros de la app`)
};

/**
* | output |
* | --- |
* | "Could not prepare app logs" |
*
* @param {Settings_Could_Not_Prepare_App_LogsInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const settings_could_not_prepare_app_logs = /** @type {((inputs?: Settings_Could_Not_Prepare_App_LogsInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_Could_Not_Prepare_App_LogsInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_settings_could_not_prepare_app_logs(inputs)
	return en_settings_could_not_prepare_app_logs(inputs)
});